export function fetchSiteInfo(baseURL: string): { name: string } | null {
  try {
    return {
      name: new URL(baseURL).hostname
    }
  } catch {
    return null
  }
}
